import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // Vite 프로젝트이므로 next-themes 대신 시스템 테마 직접 감지
  const theme = "light" // 또는 필요시 다크 모드 감지 로직 추가

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={{
        "--normal-bg": "hsl(var(--background))",
        "--normal-border": "hsl(var(--border))",
        "--normal-text": "hsl(var(--foreground))",
        "--success-bg": "hsl(var(--primary))",
        "--success-text": "hsl(var(--primary-foreground))",
        "--error-bg": "hsl(var(--destructive))", 
        "--error-text": "hsl(var(--destructive-foreground))",
      } as React.CSSProperties}
      toastOptions={{
        style: {
          background: "var(--normal-bg)",
          border: "1px solid var(--normal-border)",
          color: "var(--normal-text)",
        },
        classNames: {
          toast: "!bg-background !text-foreground !border-border shadow-lg",
          error: "!bg-destructive !text-destructive-foreground !border-destructive",
          success: "!bg-primary !text-primary-foreground !border-primary", 
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
